<template>
  <TableWrapper
    mode="customer"
    :sumCount="count"
    :title="tableTitle"
    icon="mdi-account-group-outline"
    :showFilterButton="shouldShowFilterButton"
    filterMode="customers"
    :isTablet="isTablet"
    :isLaptop="isLaptop"
  >
    <div class="customer-table-content" @scroll="handleScroll">
      <StickyTableHeader
        tableLineMaxWidth="fit-content"
        headerWidth="100%"
        :tableInfoLinesHeader="customerTableInfoLinesHeader"
        :showHeader="showHeader"
        :isMobile="isMobile"
      />
      <div class="d-flex flex-column ga-3 pa-5">
        <CustomerTableLine
          v-for="(customer, index) in customersList"
          :key="customer.cust"
          :cust="customer.cust"
          :customer="customer"
          :currentExpandBtn="currentExpandBtn"
          :tableLineBackground="
            isOdd(index + 1) ? '#ffefdb' : 'transparent'
          "
          @close-expand="setCurrentExpandBtn"
          @set-current-expand-btn="setCurrentExpandBtn"
        />
      </div>
    </div>
  </TableWrapper>
  <v-pagination
    v-model="page"
    :active-color="'blue'"
    :length="numberOfPages"
    :total-visible="5"
  ></v-pagination>
</template>

<script>
import CustomerTableLine from "./CustomerTableLine.vue";
import TableWrapper from "./TableWrapper.vue";
import StickyTableHeader from "./StickyTableHeader.vue";
import { mapGetters } from "vuex";
import { isOdd, truncateText } from "../../utilities";

export default {
  components: { CustomerTableLine, TableWrapper, StickyTableHeader },
  props: ["customersList", "count"],
  emits: ["getCustomersPagination"],
  data() {
    return {
      currentExpandBtn: -1,
      page: 1,
      showHeader: false,
      customerTableInfoLinesHeader: [
        this.$t(`customers.table.columns.customer`),
        this.$t(`customers.table.columns.address`),
        this.$t(`customers.table.columns.distLineDays`),
        this.$t(`customers.table.columns.agent`),
        this.$t("tommorowOrdersCusts.table.columns.tommorowOrderStatus"),
        this.$t(`customers.table.columns.balance`),
                this.$t(`customers.table.columns.showInvoice`),
        this.$t(`customers.table.columns.actions`),
      ],
    };
  },
  watch: {
    page() {
      var query = {
        ...this.$route.query,
        page: this.page,
      };

      this.$router.push({ path: this.$route.path, query: query });
    },
    "$route.query": {
      immediate: true,
      handler() {
        this.page = 1;
      },
    },
    "$route.query.page": {
      immediate: true,
      handler() {
        if (this.$route.query.page) {
          if (this.$route.query.page > this.numberOfPages) {
            this.page = this.numberOfPages;
          } else this.page = Number(this.$route.query.page);
        }
      },
    },
  },

  methods: {
    isOdd(number) {
      return isOdd(number);
    },
    setCurrentExpandBtn(custId = -1) {
      this.currentExpandBtn = custId;
    },
    handleScroll(event) {
      this.showHeader = event.target.scrollTop > 0;
    },
  },
  computed: {
    tableTitle() {
      // return "לקוחות";
      if (this.$route.params.custType === "tommorowcustomers") {
        return this.$t("tommorowOrdersCusts.table.tommorowcustomersTitle");
      } else {
        const tabText = this.$t(
          "tommorowOrdersCusts.table.customersMadeTommorowOrder"
        );
        if (!this.isMobile) return tabText;
        return truncateText(tabText, 18);
      }
    },
    numberOfPages() {
      if (
        this.count === 0 ||
        this.$route.params.custType === "customersMadeTommorowOrder"
      )
        return 1;
      return Math.ceil(this.count / 30);
    },
    shouldShowFilterButton() {
      return this.isMobile || this.isTablet || this.isLaptop;
    },
    ...mapGetters({
      isMobile: "isMobile",
      isTablet: "isTablet",
      isLaptop: "isLaptop",
    }),
  },
};
</script>

<style scoped lang="scss">
.customer-table-content {
  position: relative;
  height: calc(100vh - 200px);
  overflow-y: auto;
}
</style>
